import React from 'react';
import examples from 'libphonenumber-js/examples.mobile.json';
import { getExampleNumber } from 'libphonenumber-js';
import { Select } from '../select';
import { Input } from '../input';
import { ErrorText, HelperText, InputContainer, Label, Numero, Prefijo, TextWrapper } from './mixins';
const PhoneInputComponent = ({ countriesReverseCode, phone, countriesCode, formatError, errorMessageHandler, changeInputHandler, label, rules, maxHeight, placeholder, setFormatError, formatErrorText, disabled, }) => {
    var _a;
    return (React.createElement(InputContainer, null,
        React.createElement(Prefijo, null,
            React.createElement(Select, { name: "prefijo", value: countriesReverseCode[phone.prefijo], options: countriesCode, errors: formatError ? { prefijo: ' ' } : {}, onChange: (_, option) => {
                    errorMessageHandler(option.value, phone.numero);
                    changeInputHandler(option.value, phone.numero);
                }, fieldOptions: {
                    // eslint-disable-next-line prettier/prettier
                    label: label && React.createElement(Label, { required: rules === null || rules === void 0 ? void 0 : rules.required }, label),
                    variant: 'darken',
                    maxHeight,
                }, reactSelectOptions: { isClearable: false, isSearchable: true }, disabled: disabled })),
        React.createElement(Numero, null,
            React.createElement(Input, { type: "number", id: "numero", name: "numero", errors: formatError ? { numero: ' ' } : {}, value: phone.numero, onChange: (e) => changeInputHandler(phone.prefijo, e.target.value), placeholder: placeholder, onBlur: (e) => errorMessageHandler(phone.prefijo, e.target.value), onFocus: () => setFormatError(false), fieldOptions: {
                    label: ' ',
                    variant: 'darken',
                }, disabled: disabled })),
        React.createElement(TextWrapper, null,
            !formatError && phone.prefijo && (React.createElement(HelperText, null,
                "Ej. ", (_a = getExampleNumber(countriesReverseCode[phone.prefijo].code, examples)) === null || _a === void 0 ? void 0 :
                _a.nationalNumber)),
            formatError && React.createElement(ErrorText, null, formatErrorText))));
};
export default PhoneInputComponent;
